import { render, staticRenderFns } from "./404.vue?vue&type=template&id=30ca96d9&scoped=true&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"
import style1 from "./404.vue?vue&type=style&index=1&id=30ca96d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ca96d9",
  null
  
)

export default component.exports